<a href="#main-content" class="skip-link btn--primary">{{ 'Accessibility.skip_to_main_content' | translate }}</a>
<router-outlet></router-outlet>
<app-loading></app-loading>

<!-- <ng-template #cookiesModal>
  <app-modal-cookies (saveCookies)="onSaveCookies($event)"></app-modal-cookies>
</ng-template> -->
